var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAfghanistan({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_759_7690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2174 1.19072C15.6397 0.427875 13.8698 0 12 0C10.1302 0 8.36025 0.427875 6.78262 1.19072L5.73914 12L6.78262 22.8093C8.36025 23.5721 10.1302 24 12 24C13.8698 24 15.6397 23.5721 17.2174 22.8093L18.2609 12L17.2174 1.19072Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78263 1.19114C2.76872 3.13209 0 7.24252 0 12C0 16.7575 2.76872 20.8679 6.78263 22.8089V1.19114Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2173 1.19114V22.8089C21.2313 20.8679 24 16.7575 24 12C24 7.24252 21.2313 3.13209 17.2173 1.19114Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7.82611C9.69478 7.82611 7.82611 9.69483 7.82611 12C7.82611 14.3052 9.69483 16.1739 12 16.1739C14.3052 16.1739 16.1739 14.3052 16.1739 12C16.1739 9.69483 14.3052 7.82611 12 7.82611ZM12 14.6087C10.5593 14.6087 9.39131 13.4407 9.39131 12C9.39131 10.5593 10.5593 9.39131 12 9.39131C13.4407 9.39131 14.6087 10.5593 14.6087 12C14.6087 13.4407 13.4408 14.6087 12 14.6087Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.4348C11.4237 10.4348 10.9565 10.902 10.9565 11.4783V13.0435H13.0435V11.4783C13.0435 10.902 12.5764 10.4348 12 10.4348Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_759_7690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfghanistan);
export default __webpack_public_path__ + "static/media/afghanistan.52e45f41687adc26aad26d8385ddb515.svg";
export { ForwardRef as ReactComponent };